import React from "react";
import { Box, Typography } from "@mui/material";
import LanguageToggle from "./LanguageToggle";
import ThemeToggle from "./ThemeToggle";

const ControlsBar: React.FC = () => (
  <Box sx={{
    position: "fixed", top: 16, right: 16,
    zIndex: 1200, display: "flex", alignItems: "center", gap: 1,
    direction: "ltr",
  }}>
    <Box
      component="a"
      href="/"
      onContextMenu={(e: React.MouseEvent) => e.preventDefault()}
      sx={{
        display: "flex", alignItems: "center", gap: 0.75, mr: 0.5,
        textDecoration: "none", color: "text.secondary",
        "&:hover": { color: "text.primary" },
        transition: "color 0.2s ease",
      }}
    >
      <Box sx={{
        width: 24, height: 24, borderRadius: "7px", flexShrink: 0,
        background: `url(${process.env.PUBLIC_URL}/icon.svg) center/contain no-repeat`,
        userSelect: "none",
      }} />
      <Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.8rem", userSelect: "none" }}>
        Home
      </Typography>
    </Box>
    <LanguageToggle />
    <ThemeToggle />
  </Box>
);

export default ControlsBar;
